import { useState } from "react";
import clsx from "clsx";
import Modal from "react-overlays/Modal";
import classes from "./ImageModal.module.css";

interface ImageModalInterface {
  path: string;
  alt: string;
  url: string;
  currentUrl: string;
  onParagraphClick: (url: string) => void;
  width?: string;
}

const ImageModal = ({
  path,
  alt,
  url,
  currentUrl,
  onParagraphClick,
  width,
}: ImageModalInterface) => {
  const [zoomed, setZoomed] = useState(false);

  const image = (
    <div>
      <img
        onClick={() => setZoomed(true)}
        className={clsx([classes.image])}
        src={path}
        alt={alt}
        style={{
          width: zoomed ? undefined : width,
          margin: !zoomed && width !== undefined ? "0 auto" : undefined,
        }}
      />
      <p
        className={clsx(classes.imageAlt, [
          !zoomed && url && classes.clickable,
        ])}
        dangerouslySetInnerHTML={{ __html: alt }}
        onClick={() => onParagraphClick(url)}
        style={{
          backgroundColor: currentUrl === url && !zoomed ? "white" : undefined,
        }}
      ></p>
    </div>
  );

  return (
    <>
      {image}
      <Modal
        onEscapeKeyDown={() => setZoomed(false)}
        onClick={() => setZoomed(false)}
        className={classes.imageModal}
        show={zoomed}
      >
        {image}
      </Modal>
    </>
  );
};

export default ImageModal;
